module.exports = __webpack_public_path__ + "static/logo-kjpp-0be23cf89d19d712b22e983966237318.png";